import * as ActionTypes from '../actions/actionTypes'

export default function reduce(state = {}, action) {
    switch(action.type) {
        case ActionTypes.myActionType:

	break;

	default:
	    return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/index.js


// WEBPACK FOOTER //
// webpack:///src/reducers/index.js